// extracted by mini-css-extract-plugin
export var video = "video-box-module--video--Y-5fp";